import { PageInfo, TableFetchData } from "@powerledger/ui-component-lib";
import { Column } from "react-table";

import { ReturnTypeFormatAttributes } from "@/app/lib/format-attributes";
import { RECOrderAttributeOptions } from "@/app/lib/format-rec-options";
import {
  ERCOTUnSupportedColumns,
  MRETSUnSupportedColumns,
  UnSupportedColumns,
} from "@/app/lib/registry-attributes-helpers";
import { CounteredOrdersQuery, RecAttributes, RegistryCode } from "@/app/types/generated/graphql";

export type CounteredOrdersData = Omit<CounteredOrdersQuery["counteredOrders"]["orders"][0], "attributes"> & {
  attributes: RecAttributes;
} & ReturnTypeFormatAttributes;

export type CounteredOrdersProps = {
  showAllAttributes: boolean;
  setShowAllAttributes: React.Dispatch<React.SetStateAction<boolean>>;
  recOptions?: RECOrderAttributeOptions;
  tableData: CounteredOrdersData[];
  titles: string;
  userMessage: string;
  loading: boolean;
  onSeeCounterOffers: (recs: CounteredOrdersData) => void;
  tableColumns: Column<CounteredOrdersData>[];
  reloadCounteredOrders: () => void;
  fetchData: TableFetchData<CounteredOrdersData>;
  pageInfo: PageInfo;
  hiddenColumns: string[];
  isActiveRegistryErcot: boolean;
};

export type TableDataProps = {
  id: string;
  receivedOn: string;
  counterNumber: string;
  status: string;
};

export enum OffersTitle {
  INCOMING = "Received Counter Offers",
  OUTGOING = "My Counter Offers",
}

export enum OffersPageDesc {
  INCOMING = "Here is the list of sell orders that have received counter offers.",
  OUTGOING = "Here is the list of sell orders, you have submitted counter offers for.",
}

export enum RoutePaths {
  INCOMING = "/counter/received-offers/offers",
  OUTGOING = "/counter/my-offers/offers",
}

export enum GoBackPaths {
  INCOMING = "/counter/received-offers",
  OUTGOING = "/counter/my-offers",
}

export enum HeadersTitle {
  INCOMING = "Order Number",
  OUTGOING = "Order Reference",
}

export const CounteredOrderUnSupportedColumns: UnSupportedColumns = {
  [RegistryCode.Mrets]: {
    unsupportedColumns: MRETSUnSupportedColumns,
    toggleColumns: ["commencementDate", "locations", "projects"],
  },
  [RegistryCode.Ercot]: {
    unsupportedColumns: ERCOTUnSupportedColumns,
    toggleColumns: ["commencementDate", "projects"],
  },
};
